import { render, staticRenderFns } from "./addNew2.vue?vue&type=template&id=9a06cc88&scoped=true&"
import script from "./addNew2.vue?vue&type=script&lang=js&"
export * from "./addNew2.vue?vue&type=script&lang=js&"
import style0 from "./addNew2.vue?vue&type=style&index=0&id=9a06cc88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a06cc88",
  null
  
)

export default component.exports